import { CollaborationServiceSetup, ControllerHelper, ScormController, ScormInfo } from "collaboration-service";
import { RangeSliderSC as TT } from "components/RangeSlider/RangeSliderSC";
import { LoaderInline } from "imaginarity-react-ui";
import * as React from "react";
import InputRange from "react-input-range";
import { useImgI18N } from "services/ImgI18N";
import { AICC, Scorm12API, Scorm2004API } from "./API/ScormAgain";
import { Settings } from "./API/types/api_types";
import { LogLevelEnum } from "./API/constants/enums";
import BaseAPI from "./API/BaseAPI";

interface ScormContainerProps {
    id: string;
    withZoom?: boolean;
    height?: string | number;
    playlistStateId?: string;
    metaData?: string;
}

const settings: Settings = {
    logLevel: LogLevelEnum.DEBUG,
    onLogMessage: (lvl, msg) => console.log(msg),
    asyncCommit: true,
    autocommit: true,
    autocommitSeconds: 5,
}

const ScormContainer = (p: ScormContainerProps) => {
    const { id, withZoom, height, playlistStateId, metaData } = p;
    const { t } = useImgI18N("scorm");

    const [info, setInfo] = React.useState<ScormInfo>();
    const [initScorm, setInitScorm] = React.useState<boolean>(false);
    const [hasError, setHasError] = React.useState<boolean>();
    const [zoom, setZoom] = React.useState<number>(50);

    const s = withZoom ? zoom / 100.0 : 1;
    React.useEffect(() => {
        if (!info) return;
        const init = async () => {
            try {
                setInitScorm(false);
                console.log("ScormContainer.tsx::20 => settings", settings);

                const reg = await ControllerHelper.singleCall({ courseId: id, playlistStateId: playlistStateId ?? "", metaData }, ScormController.CreateOrGetRegistration, true);
                console.log("ScormContainer.tsx::16 => reg", reg);
                if (!reg)
                    throw new Error("Could not create or get registration for SCORM content");

                const regEntry = await ControllerHelper.singleCall({ regId: reg.id, apiVersion: "Scorm_1_2" }, ScormController.RegistrationInitialize, true);
                console.log("ScormContainer.tsx::23 => res", regEntry);
                if (!regEntry)
                    throw new Error("Could not create or get registration entry for SCORM content");

                const commitHandler = (api: BaseAPI) => {
                    console.log(`ScormContainer.tsx::28 => commitHandler called`);
                    const save = async () => {
                        const data = api.renderCMIToJSONObject();
                        console.log("ScormContainer.tsx::31 => json", data);
                        const res = await ControllerHelper.singleCall({ regEntryId: regEntry.id, data }, ScormController.RegistrationCommit, true);
                        console.log("ScormContainer.tsx::34 => res", res);
                    };
                    save();
                }
                const finish = (api: BaseAPI) => {
                    // const save = async () => {
                    //     const res = await ControllerHelper.singleCall({ regEntryId: regEntry.id }, ScormController.RegistrationFinish, true);
                    //     console.log("ScormContainer.tsx::42 => res", res);
                    // }
                    // save();
                }

                settings.commitHandler = commitHandler;
                settings.finishHandler = finish;
                var api: BaseAPI | undefined;


                switch (info.scormVersionDiscrete) {
                    case "V_1_2":
                        (window as any).API = new AICC(settings);
                        (window as any).API = new Scorm12API(settings);
                        api = (window as any).API;
                        break;
                    case "V_2004":
                        (window as any).API_1484_11 = new Scorm2004API(settings);
                        api = (window as any).API_1484_11;
                        break;
                }
                if (api) {
                    console.log("Registering handlers...");
                    if (regEntry.cmiData && regEntry !== null)
                        api.loadFromJSON(regEntry.cmiData);

                    // api.clear("LMSCommit");
                    // api.on("LMSCommit", commitHandler(api));

                    // api.clear("LMSFinish");
                    // api.on("LMSFinish", finish(api));
                }
            }
            catch (e) {
                console.log("Error initializing SCORM:", e);
                (window as any).API = new AICC(settings);
                (window as any).API = new Scorm12API(settings);
                (window as any).API_1484_11 = new Scorm2004API(settings);
            } finally {
                setInitScorm(true);
            }
        };
        init();

    }, [info, id, playlistStateId, metaData]);

    React.useEffect(() => {
        const l = async () => {
            const res = await ControllerHelper.singleCall({ id }, ScormController.GetInfo, true);
            if (!res)
                setHasError(true);
            setInfo(res);
        }
        l();
        return () => {
            setInfo(undefined);
            setHasError(false);
        }
    }, [id]);

    console.log(info);

    if (hasError)
        return <div>{t("could not parse scorm package!")}</div>
    if (!info)
        return <LoaderInline active infoText={t("parsing scorm info")} />
    if (!initScorm)
        return <LoaderInline active infoText={t("initializing scorm")} />
    return (
        <>
            <div style={{ width: "100%", height: height ?? 300 }}>
                <iframe
                    src={`${CollaborationServiceSetup.client.baseUrl}api/scorm/content/${id}`}
                    title="preview"
                    style={{ width: `${100 / s}%`, height: `${100 / s}%`, transform: `scale(${s})`, transformOrigin: "top left" }}
                    allowFullScreen
                />
            </div>
            {withZoom &&
                <TT.Container
                    rangeBarColor={"@accent"}
                    hideValues={false}
                    marginBottom={30}
                >
                    <InputRange
                        step={1}
                        draggableTrack={true}
                        allowSameValues={true}
                        minValue={10}
                        maxValue={100}
                        disabled={false}
                        value={zoom}
                        formatLabel={f => `zoom ${f}%`}
                        onChange={n => {
                            console.log("CMSMiniPreview.tsx::93 => n", n);

                            typeof n === "number" ? setZoom(n) : setZoom(n.min)
                        }}
                    />
                </TT.Container>
            }
        </>
    )
}

export default ScormContainer;